/* Moved from snippets/hlth-block-review-photos.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(BID) {
                          (function () {
                            var root = document.querySelector('.hlth-rp-' + BID + '');
                            if (!root || root.dataset.hlthRpInit === '1') return;
                            root.dataset.hlthRpInit = '1';

                            // Thumbnails load after the page (or as soon as the strip is on screen),
                            // so they never compete with the pack shot (speed audit, 15 Oct 2026).
                            var thumbsLoaded = false;
                            function loadThumbs() {
                              if (thumbsLoaded) return;
                              thumbsLoaded = true;
                              root.querySelectorAll('img[data-hlth-rp-srcset]').forEach(function (img) {
                                img.srcset = img.getAttribute('data-hlth-rp-srcset');
                                img.removeAttribute('data-hlth-rp-srcset');
                              });
                            }
                            if (document.readyState === 'complete') {
                              loadThumbs();
                            } else {
                              window.addEventListener('load', loadThumbs);
                              if ('IntersectionObserver' in window) {
                                var thumbIo = new IntersectionObserver(function (entries) {
                                  if (entries.some(function (e) { return e.isIntersecting; })) {
                                    thumbIo.disconnect();
                                    loadThumbs();
                                  }
                                });
                                var track = root.querySelector('.hlth-rp-track');
                                if (track) thumbIo.observe(track);
                              }
                            }

                            var modal = root.querySelector('.hlth-rp-modal');
                            var slot = modal.querySelector('[data-hlth-rp-slot]');
                            var closeBtn = modal.querySelector('.hlth-rp-close');
                            var lastTrigger = null;
                            var scrollY = 0;

                            // Portal the modal to document.body so position: fixed resolves
                            // to the viewport regardless of transformed ancestors in the
                            // product section. Otherwise the modal can render off-screen.
                            if (modal.parentElement !== document.body) {
                              document.body.appendChild(modal);
                            }

                            function lockScroll() {
                              scrollY = window.scrollY || window.pageYOffset || 0;
                              var b = document.body;
                              b.style.position = 'fixed';
                              b.style.top = '-' + scrollY + 'px';
                              b.style.left = '0';
                              b.style.right = '0';
                              b.style.width = '100%';
                            }
                            function unlockScroll() {
                              var b = document.body;
                              b.style.position = '';
                              b.style.top = '';
                              b.style.left = '';
                              b.style.right = '';
                              b.style.width = '';
                              window.scrollTo(0, scrollY);
                            }

                            function openReview(id, trigger) {
                              var tpl = root.querySelector('template[data-hlth-rp-content="' + id + '"]');
                              if (!tpl) return;
                              slot.innerHTML = '';
                              slot.appendChild(tpl.content.cloneNode(true));
                              slot.scrollTop = 0;
                              modal.classList.add('is-open');
                              modal.setAttribute('aria-hidden', 'false');
                              lockScroll();
                              lastTrigger = trigger || null;
                              setTimeout(function () { closeBtn.focus(); }, 30);
                            }

                            function closeReview() {
                              if (!modal.classList.contains('is-open')) return;
                              modal.classList.remove('is-open');
                              modal.setAttribute('aria-hidden', 'true');
                              unlockScroll();
                              if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
                              setTimeout(function () {
                                if (!modal.classList.contains('is-open')) slot.innerHTML = '';
                              }, 320);
                            }

                            root.addEventListener('click', function (e) {
                              var opener = e.target.closest('[data-hlth-rp-open]');
                              if (opener && root.contains(opener)) {
                                e.preventDefault();
                                openReview(opener.getAttribute('data-hlth-rp-open'), opener);
                              }
                            });

                            // Modal lives on document.body now, so close clicks don't
                            // bubble to `root` — listen on the modal directly.
                            modal.addEventListener('click', function (e) {
                              var closer = e.target.closest('[data-hlth-rp-close]');
                              if (closer && modal.contains(closer)) {
                                e.preventDefault();
                                closeReview();
                              }
                            });

                            document.addEventListener('keydown', function (e) {
                              if (e.key === 'Escape' && modal.classList.contains('is-open')) closeReview();
                            });

                            // Infinite-loop scroll: clone the thumb set before and after
                            // the originals, start scrolled to the middle set, and wrap
                            // seamlessly when the user scrolls past either edge.
                            (function setupLoop() {
                              var track = root.querySelector('.hlth-rp-track');
                              if (!track) return;
                              var origThumbs = Array.prototype.slice.call(track.querySelectorAll('.hlth-rp-thumb'));
                              if (origThumbs.length < 2) return;

                              function makeClone(el) {
                                var c = el.cloneNode(true);
                                c.setAttribute('aria-hidden', 'true');
                                c.setAttribute('tabindex', '-1');
                                c.setAttribute('data-hlth-rp-clone', '1');
                                return c;
                              }

                              var prependFrag = document.createDocumentFragment();
                              var appendFrag = document.createDocumentFragment();
                              for (var i = 0; i < origThumbs.length; i++) {
                                prependFrag.appendChild(makeClone(origThumbs[i]));
                                appendFrag.appendChild(makeClone(origThumbs[i]));
                              }
                              track.insertBefore(prependFrag, track.firstChild);
                              track.appendChild(appendFrag);

                              var setWidth = 0;
                              var isResetting = false;
                              var lastScrollLeft = 0;
                              // Speed cap: max pixels the track can advance per scroll event.
                              // Keeps a fast flick from overshooting the wrap logic or
                              // blowing past several items in a single frame.
                              var MAX_SCROLL_DELTA = 80;

                              function measure() {
                                var firstOrig = track.children[origThumbs.length];
                                var firstAppend = track.children[origThumbs.length * 2];
                                if (firstOrig && firstAppend) {
                                  setWidth = firstAppend.offsetLeft - firstOrig.offsetLeft;
                                }
                              }

                              function jumpScroll(to) {
                                isResetting = true;
                                var snap = track.style.scrollSnapType;
                                var behavior = track.style.scrollBehavior;
                                track.style.scrollSnapType = 'none';
                                track.style.scrollBehavior = 'auto';
                                track.scrollLeft = to;
                                lastScrollLeft = to;
                                requestAnimationFrame(function () {
                                  track.style.scrollSnapType = snap;
                                  track.style.scrollBehavior = behavior;
                                  isResetting = false;
                                });
                              }

                              function centerInitial() {
                                measure();
                                if (setWidth <= 0) return;
                                jumpScroll(setWidth);
                              }

                              centerInitial();
                              // Images use fixed thumb widths so layout is stable immediately,
                              // but re-center on full load in case fonts/layout shift width.
                              window.addEventListener('load', centerInitial);

                              track.addEventListener('scroll', function () {
                                if (isResetting || setWidth <= 0) return;
                                var sl = track.scrollLeft;
                                var delta = sl - lastScrollLeft;
                                // Cap scroll delta so momentum flicks can't blow past the wrap.
                                if (Math.abs(delta) > MAX_SCROLL_DELTA) {
                                  jumpScroll(lastScrollLeft + (delta > 0 ? MAX_SCROLL_DELTA : -MAX_SCROLL_DELTA));
                                  return;
                                }
                                lastScrollLeft = sl;
                                // Modulo-wrap any position outside the middle set back into it,
                                // so even a fast overshoot resolves in a single step.
                                if (sl < setWidth || sl >= setWidth * 2) {
                                  var rel = sl - setWidth;
                                  var wrapped = ((rel % setWidth) + setWidth) % setWidth;
                                  jumpScroll(setWidth + wrapped);
                                }
                              }, { passive: true });

                              window.addEventListener('resize', function () {
                                var old = setWidth;
                                measure();
                                if (setWidth > 0 && old > 0 && setWidth !== old) {
                                  var posInSet = track.scrollLeft - old;
                                  jumpScroll(setWidth + posInSet * (setWidth / old));
                                }
                              });
                            })();
                          })();

  }
  function scan(scope) {
    scope.querySelectorAll(".hlth-rp-block").forEach(function (root) {
      if (root.__hlthJs_hlth_block_review_photos) return;
      root.__hlthJs_hlth_block_review_photos = true;
      run(root.getAttribute('data-hlth-bid'));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
